// extracted by mini-css-extract-plugin
module.exports = {"vacancySkeleton":"VacancySkeleton_vacancySkeleton_2kTxh","subheaderSkeleton":"VacancySkeleton_subheaderSkeleton_OXvkG"};